module.exports = __webpack_public_path__ + "img/20220624173943.dcb7d450.png";